<h1 mat-dialog-title class="title">{{ 'ModalConfirmationDialog.' + data.titleResourceKey | translate:{parameter:
  data.parameter} }}</h1>

<div mat-dialog-actions>
  <button mat-button (click)="onYesClick()">{{ 'ModalConfirmationDialog.YesButton' | translate }}</button>
  <button mat-button (click)="onNoClick()" cdkFocusInitial>{{ 'ModalConfirmationDialog.NoButton' | translate }}</button>
</div>
